import { render } from "./AboutPthGjakova.vue?vue&type=template&id=2f4dbd0e&scoped=true"
import script from "./AboutPthGjakova.vue?vue&type=script&lang=js"
export * from "./AboutPthGjakova.vue?vue&type=script&lang=js"

import "./AboutPthGjakova.vue?vue&type=style&index=0&id=2f4dbd0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4dbd0e"]])

export default __exports__